import type { FC } from 'react';
import { Label, Radio } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

import { toggleGroupButton } from './classes';
import type { ToggleOptionProps } from './types';

export const ToggleOption: FC<ToggleOptionProps> = ({
  position,
  option,
  size,
  isFullWidth,
  isIncomplete,
  onClick,
  disabled,
  checked,
}) => {
  const { label, value } = option;

  return (
    <Radio
      onClick={() => onClick(value)}
      value={value}
      data-testid={label}
      title={label}
      disabled={disabled}
      className={twMerge(
        toggleGroupButton({
          checked,
          disabled,
          size,
          position,
          isIncomplete,
        }),
        isFullWidth && 'flex-1 justify-center',
      )}
    >
      <Label as="span">{label}</Label>
    </Radio>
  );
};
